(function(){
    angular
        .module('app')
        .directive('parseInt', parseintdir);
        parseintdir.$inject = ['$timeout'];
        function parseintdir($timeout){
            return {
            restrict: 'A',
        	require: 'ngModel',
            link: function (scope, elem, attrs, controller) {
	            controller.$formatters.push(function (modelValue) {
                    console.log(modelValue);
	                return (modelValue==1 ? true : false);
	            });
	        }
          }
      }
})();